import ReactDOM from 'react-dom/client';
import {Helmet, HelmetProvider} from 'react-helmet-async';
import Modal from 'react-modal';
import {
  createBrowserRouter,
  createRoutesFromElements, Navigate,
  Route,
  RouterProvider,
} from 'react-router';
import {Slide, ToastContainer} from 'react-toastify';

import {EditContextProvider} from 'components/Edit/EditContext';
import {ModalServiceProvider} from 'components/shared/ModalService';
import {AppContextProvider} from 'conf/AppContext';
import AuthProvider from 'context/AuthContext';
import ThemeProvider from 'context/ThemeContext';
import NotFound from 'pages/NotFound';
import ProtectedRoute from 'pages/ProtectedRoute';
import Restricted from 'pages/Restricted';
import CompanyPage from 'pages/admin/company';
import TechStackPage from 'pages/admin/techStack';
import UserPage from 'pages/admin/user';
import Authentication from 'pages/developer/profile/Authentication';
import Authorization from 'pages/developer/profile/Authorization';
import DashboardPage from 'pages/protected/dashboard';
import ProtectedGitHubPage from 'pages/protected/dashboard/github';
import PasswordPage from 'pages/protected/dashboard/password';
import ProfilePage from 'pages/protected/dashboard/profile';
import ScorePage from 'pages/protected/dashboard/score';
import SettingsPage from 'pages/protected/dashboard/settings';
import UserTechStackPage from 'pages/protected/dashboard/techStack';
import LoginPage from 'pages/public/accessManagement/Login';
import MfaPage from 'pages/public/accessManagement/Mfa';
import RegisterPage from 'pages/public/accessManagement/Register';
import ResetPassword from 'pages/public/accessManagement/ResetPassword';
import VerifyAccount from 'pages/public/accessManagement/VerifyAccount';
import VerifyPassword from 'pages/public/accessManagement/VerifyPassword';
import CompanyTechStackPage from 'pages/public/companyTechStack';
import GitHubListPage from 'pages/public/github/list';
import GitHubProfilePage from 'pages/public/github/profile';
import GitHubSearchPage from 'pages/public/github/search';
import Navbar from 'pages/public/navbar';
import StatsPage from 'pages/public/stats';
import UsersTechStackPage from 'pages/public/usersTechStack';

import App from './App';
import './styles/main.scss';


const helmetContext = {};
Modal.setAppElement('#root');


const router = createBrowserRouter(createRoutesFromElements(
  <Route path="/" element={<App />}>
    <Route element={<Navbar />}>
      <Route path="/" element={<GitHubSearchPage />} />
      <Route path="github" element={<GitHubListPage />} />
      <Route path="github/profile/:id" element={<GitHubProfilePage />} />
      <Route path="ninjas" element={<UsersTechStackPage />} />
      <Route path="companyTechStack" element={<CompanyTechStackPage />} />
      <Route path="stats" element={<StatsPage />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="register" element={<RegisterPage />} />
      <Route path="mfa" element={<MfaPage />} />
      <Route path="resetpassword" element={<ResetPassword />} />
      <Route path="verify/password" element={<VerifyPassword />} />
      <Route path="verify/account" element={<VerifyAccount />} />

      <Route element={<ProtectedRoute />}>
        <Route path="dashboard/companies" element={<Navigate to="/companies" />} />
        <Route path="/dashboard" element={<DashboardPage />}>
          <Route path="/dashboard" element={<Navigate to="/dashboard/score" />} />
          <Route path="score" element={<ScorePage />} />
          <Route path="github" element={<ProtectedGitHubPage />} />
          <Route path="techStack" element={<UserTechStackPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="password" element={<PasswordPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="authorization" element={<Authorization />} />
          <Route path="authentication" element={<Authentication />} />
          <Route path="status" element={<div>Coming soon...</div>} />
        </Route>
        <Route element={<Restricted />}>
          <Route path="dashboard/edit/users" element={<UserPage />} />
          <Route path="dashboard/edit/companies" element={<CompanyPage />} />
          <Route path="dashboard/edit/techStacks" element={<TechStackPage />} />
        </Route>
      </Route>
    </Route>
    <Route path="*" element={<NotFound />} />
  </Route>,
));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AppContextProvider>
    <ThemeProvider>
      <AuthProvider>
        <ModalServiceProvider>
          <HelmetProvider context={helmetContext}>
            <Helmet>
              <title>Fuzzy Score</title>
            </Helmet>
            <EditContextProvider forceEditMode={true}>
              <RouterProvider router={router} />
            </EditContextProvider>
            <ToastContainer transition={Slide} draggable={false} icon={false} />
          </HelmetProvider>
        </ModalServiceProvider>
      </AuthProvider>
    </ThemeProvider>
  </AppContextProvider>,
);
